import React from "react";
import { FormattedMessage } from "react-intl";

const URL_REGEX: RegExp = new RegExp(
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\\+.~#?&/=]*)/i,
);

export default (value: any) => {
  if (typeof value !== "string" || value === "") {
    return undefined;
  }

  if (!URL_REGEX.test(value)) {
    return <FormattedMessage id="form.validations.web_link.invalid" />;
  }

  return undefined;
};
